import {Person} from "../../../services/interface/query/person";
import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import NotPermissionComponent from "../NotPermissionComponent";
import {useFindChecklistHomonyms} from "../../../services/apis/apiChecklist";
import {ChecklistHomonymDetailInterface} from "../../../services/interface/query/checklist-interface";
import NoRecords from "../../components/NoRecords";
import * as IconsMui from "@mui/icons-material";
import {IconButton, Collapse} from "@material-tailwind/react";
import CustomTable from "../../../components/general/CustomTable";

interface Props {
    person?: Person;
}

/**
 * Muestra homónimos asociados a la persona consultada.
 * Consume el endpoint POST /control_lists/homonyms.
 *
 * @author cfernandez
 * @version 1.0.0
 * @since 2026-04-08
 */
export default function ChecklistHomonyms({person}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: findHomonyms,
        data: successHomonyms,
        error: errorHomonyms,
        isPending: loadingHomonyms,
    } = useFindChecklistHomonyms()

    const [response, setResponse] = useState<ChecklistHomonymDetailInterface[] | null | undefined>()
    const [isOpen, setIsOpen] = React.useState(false);

    useEffect(() => {
        if (person?.identification) {
            setResponse(undefined)
            findHomonyms({identifier: person.identification, msj: t('homonyms')})
        }
    }, [person]);

    useEffect(() => {
        if (successHomonyms !== undefined) {
            setResponse(successHomonyms);
        }
    }, [successHomonyms]);

    const isResolved = response !== undefined && response !== null;
    const hasRecords = isResolved && response.length > 0;

    return (
        <NotPermissionComponent
            className={'min-h-[50px]'}
            title={'/pn_checklist'}
            loading={loadingHomonyms}
            error={errorHomonyms}
            component={
                <div>
                    <div className={'flex flex-row gap-3 !border border-transparent border-b-secondary pb-3'}>
                        {isResolved ?
                            !hasRecords ?
                                <IconsMui.EmojiEmotionsTwoTone className={'text-success'}/> :
                                <IconsMui.SentimentDissatisfiedTwoTone className={'text-danger'}/> :
                            <IconsMui.NotificationsOffTwoTone className={'text-empColorSecondary'}/>
                        }
                        {t('homonyms')}
                        <div className={'ml-auto flex flex-row gap-3 items-center'}>
                            {hasRecords &&
                                <div className={'text-[9px] font-light text-danger'}>{t('homonyms')}</div>}
                            {hasRecords &&
                                <IconButton placeholder="icon-button"
                                            size="sm"
                                            variant="text"
                                            onClick={() => setIsOpen((cur) => !cur)}
                                >
                                    <IconsMui.KeyboardArrowDownTwoTone className="h-6 w-6"/>
                                </IconButton>
                            }
                        </div>
                    </div>
                    {hasRecords ?
                        <Collapse open={isOpen} className="bg-white">
                            <CustomTable
                                classNameTable={'mt-2'}
                                header={[
                                    t('identification'),
                                    t('names'),
                                ]}
                                listElement={response?.map((item) => ({
                                    row: [
                                        item.identification,
                                        item.name,
                                    ]
                                }))}
                            />
                        </Collapse>
                        : !loadingHomonyms && isResolved && <NoRecords/>
                    }
                </div>
            }
        />
    )
}
